<h2 class="complete-profile-title">
  <button class="cursor-pointer hover:text-primary" (click)="onBack.emit()"><i class="fa-light fa-square-arrow-left text-3xl"></i></button>

  Tell us where you live
</h2>
<form appAutoValidate (submit)="submitForm($event)">
  <div class="grid grid-cols-1 gap-4">
    <div class="form-group">
      <label for="">Residence Country</label>
      <app-select-field [options]="countries()" [formField]="form.country"></app-select-field>
    </div>

    <div class="form-group">
      <label for="">Residence City</label>
      <p-autoComplete
        [suggestions]="filteredCities()"
        class="w-full"
        (completeMethod)="filterCities($event)"
        (onSelect)="updateCity($event)"
        [disabled]="!formModel().country"
        [forceSelection]="true"
        optionValue="value"
        optionLabel="label"
        placeholder="Select a city"
      >

      </p-autoComplete>
    </div>

    <div class="form-group">
      <label for="">Residence Status</label>
      <app-select-field [options]="residenceStatus()" [formField]="form.residence_status"></app-select-field>
    </div>
    <div class="form-group">
      <label for="">Citizenship Country</label>
      <app-select-field [options]="countries()" [formField]="form.citizen_country"></app-select-field>
    </div>
  </div>
  <button [disabled]="form().invalid()" class="mt-6 btn-base bg-primary text-white w-full py-3">
    @if (loading()) {
      <i class="pi pi-spinner pi-spin"></i>
    } @else {
      Next
    }
  </button>
</form>
